
import { Vue, Options } from "vue-class-component";
import { FlagsPermissionPusatResolusiV2 } from "@/feature-flags/flags-pusat-resolusi-v2";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import Checkbox from "primevue/checkbox";
import ModalCheckIssue from "./components/check-issue/modal-check-issue.vue";
import PopupIssueInformation from "./components/check-issue/popup-issue-information.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { TicketListItem } from "@/domain/entities/PusatResolusiV2";
import { PusatResolusiV2Controller } from "../../controllers/PusatResolusiV2Controller";
import { CheckTicketPusatResolusiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import PusatResolusiV2TabTicket from "./components/tab-ticket.vue";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import WidgetDownload from "./components/widget-download.vue";
import DownloadLaporan from "./components/download-laporan.vue";
import { getHubData } from "@/app/infrastructures/misc/Cookies";

@Options({
  components: {
    Skeleton,
    CustomDropdown,
    Checkbox,
    ModalCheckIssue,
    PopupIssueInformation,
    PusatResolusiV2TabTicket,
    WidgetDownload,
    DownloadLaporan
  },
})
export default class PusatResolusiV2 extends Vue {
  showModalCheckIssue = false;
  showPopupReportIssue = false;
  showPopupInformationIssue = false;
  isError = false;
  errorCause = "";
  refNo: any = "";

  mounted() {
    if (this.isInternal) {
      this.$router.replace("/pusat-resolusi-v2/list");
    } else {
      this.$router.replace("/pusat-resolusi-v2/tiket-eskalasi");
    }
  }

  onClickCheckIssueButton() {
    this.ticketListData = [];
    this.showModalCheckIssue = !this.showModalCheckIssue;
  }

  onCloseReportIssue() {
    this.showPopupReportIssue = false;
    this.onClickCheckIssueButton();
  }

  onClosePopupInformationIssue() {
    this.showPopupInformationIssue = false;
    this.onClickCheckIssueButton();
  }

  onReportIssue(refNo: any) {
    this.refNo = refNo;
    this.onCheck();
  }

  get hubId() {
    return getHubData()?.hubId || 0;
  }

  get showCekKendalaButton() {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_cek_kendala.isEnabled();
  }

  get showBuatKendalaButton() {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_buat_kendala.isEnabled();
  }

  toCreate(refNo = "") {
    const referenceNumber = refNo ? `?sttNo=${refNo}` : "";
    this.$router.push(`/pusat-resolusi-v2/create${referenceNumber}`);
  }

  handleTicketSelect(id: number) {
    this.$router.push(`/pusat-resolusi-v2/detail/${id}`);
  }

  ticketListData: TicketListItem[] = [];
  async onCheck() {
    try {
      MainAppController.showLoading();
      this.ticketListData = [];
      this.ticketListData = await PusatResolusiV2Controller.checkIssueV2(
        new CheckTicketPusatResolusiRequest({
          refNo: this.refNo,
          hubId: this.hubId
        })
      );
      if (!this.ticketListData[0]?.statusTicket) {
        this.showPopupReportIssue = true;
        this.onClickCheckIssueButton();
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        this.showPopupReportIssue = true;
        this.onClickCheckIssueButton();
      } else {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, this.$t('pusatResolusi.cekKendalaGagal'), () => {
            this.onCheck();
            MainAppController.closeErrorMessage();
          })
        );
      }
      this.ticketListData = [];
    } finally {
      MainAppController.closeLoading();
    }
  }

  closeModalError() {
    this.isError = false;
    this.errorCause = "";
  }

  get isInternal() {
    return AccountController.accountData.isInternalAccount;
  }

  get showWidgetDownload(): boolean {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_widget_laporan.isEnabled();
  }
  get showDownloadLaporan(): boolean {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_download_laporan.isEnabled();
  }
}
